
import { mapActions } from 'vuex'
export default {
  name: 'Video',
  props: {
    blok: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      showTimer: false,
      youtube: {
        player: { getCurrentTime: null },
        playerVars: {
          modestbranding: this.blok.yt_logo,
          rel: 0,
          start: this.blok.start_time,
          enablejsapi: 1,
          playsinline: 1,
          origin: process.browser ? location.origin : ''
        },
        interval: null
      }
    }
  },
  computed: {
    randIdGen() {
      return (
        'yt-' +
        Math.random()
          .toString(36)
          .substr(2, 9)
      )
    }
  },
  mounted() {
    if (this.blok.autoplay) {
      this.init()
    }

    if (this.blok.hidden_content_reveal_delay > 0 && this.blok.timer_enabled) {
      this.intervalHandler()
    }
    if (this.blok.timer_delay > 1) {
      this.$bus.$on('showTimer', show => {
        this.showTimer = show
        this.$bus.$emit('timerStart', true)
      })
    }
    this.$bus.$on('timerExpired', () => {
      this.dialog = true
    })
  },
  beforeDestroy() {
    clearInterval(this.youtube.interval)
    this.$bus.$off('showTimer')
    this.$bus.$off('timerExpired')
  },
  methods: {
    init() {
      this.loadDeps('ytScript', 'https://www.youtube.com/iframe_api').then(
        () => {
          this.youtube.player = new window.YT.Player(this.randIdGen, {
            height: '100%',
            width: '100%',
            videoId:
              this.$vuetify.breakpoint.smAndDown && this.blok.mobile_video_id
                ? this.blok.mobile_video_id
                : this.blok.video_id,
            playerVars: this.youtube.playerVars,
            events: {
              onReady: ({ target }) => target.playVideo()
            }
          })
        }
      )
    },
    intervalHandler() {
      this.youtube.interval = setInterval(() => {
        if (!this.youtube.player.getCurrentTime) {
          return
        }
        const currentTime = this.youtube.player.getCurrentTime()
        if (
          Number(currentTime) >= Number(this.blok.hidden_content_reveal_delay)
        ) {
          this.$bus.$emit('hiddenContentRevealExpired')
          this.$nextTick(() => {
            this.$bus.$emit('timerStart')
          })
          clearInterval(this.youtube.interval)
        }
      }, 300)
    },
    onClick() {
      this.$bus.$emit('offerDeclined')
      this.nextStep({ acceptOffer: false, productId: null })
    },
    loadDeps(depId, depSrc) {
      return new Promise(resolve => {
        if (process.browser && !document.getElementById(depId)) {
          const script = document.createElement('script')
          script.src = depSrc
          script.id = depId
          script.async = true
          script.onload = () => window.YT.ready(resolve)
          document.body.appendChild(script)
        } else {
          resolve()
        }
      })
    },
    ...mapActions({
      nextStep: 'nextStep'
    })
  },
  head() {
    return {
      link: [
        {
          rel: 'preconnect',
          href: 'https://i.ytimg.com'
        },
        {
          rel: 'dns-prefetch',
          href: 'https://www.youtube.com'
        }
      ]
    }
  }
}
